import { Input } from '@dtx-company/shared-components/src/components/atoms/Input/index'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'

type PlanPurchaseExperienceOrgNameInputProps = {
  label: string
  heading: string
  errorText?: string
  value: string
  onValueChange: (value: string) => void
}

export const PlanPurchaseExperienceOrgNameInput = ({
  label,
  heading,
  errorText,
  value,
  onValueChange
}: PlanPurchaseExperienceOrgNameInputProps): JSX.Element => {
  return (
    <>
      <Text variant={'header/subheader'} mt="24px">
        {heading}
      </Text>
      <Input
        type="text"
        value={value}
        error={Boolean(errorText)}
        helperText={errorText}
        labelProps={{ mb: '8px', mt: '16px' }}
        label={label}
        inputProps={{ name: 'businessName' }}
        onChange={e => {
          onValueChange(e.target.value)
        }}
      />
    </>
  )
}
